import { useContext } from 'react';

import { ConfirmDialogContext } from 'contexts/ConfirmDialog';

const useConfirmDialog = () => {
  return useContext(ConfirmDialogContext);
};

export default useConfirmDialog;
